// src/app/redux/actions/jobSkillActions.js

export const FETCH_JOB_SKILLS_REQUEST = "FETCH_JOB_SKILLS_REQUEST";
export const FETCH_JOB_SKILLS_SUCCESS = "FETCH_JOB_SKILLS_SUCCESS";
export const FETCH_JOB_SKILLS_FAIL    = "FETCH_JOB_SKILLS_FAIL";

export const CREATE_JOB_SKILL_REQUEST = "CREATE_JOB_SKILL_REQUEST";
export const CREATE_JOB_SKILL_SUCCESS = "CREATE_JOB_SKILL_SUCCESS";
export const CREATE_JOB_SKILL_FAIL    = "CREATE_JOB_SKILL_FAIL";

export const UPDATE_JOB_SKILL_REQUEST = "UPDATE_JOB_SKILL_REQUEST";
export const UPDATE_JOB_SKILL_SUCCESS = "UPDATE_JOB_SKILL_SUCCESS";
export const UPDATE_JOB_SKILL_FAIL    = "UPDATE_JOB_SKILL_FAIL";

export const DELETE_JOB_SKILL_REQUEST = "DELETE_JOB_SKILL_REQUEST";
export const DELETE_JOB_SKILL_SUCCESS = "DELETE_JOB_SKILL_SUCCESS";
export const DELETE_JOB_SKILL_FAIL    = "DELETE_JOB_SKILL_FAIL";

export const IMPORT_JOB_SKILLS_EXCEL_REQUEST = "IMPORT_JOB_SKILLS_EXCEL_REQUEST";
export const IMPORT_JOB_SKILLS_EXCEL_SUCCESS = "IMPORT_JOB_SKILLS_EXCEL_SUCCESS";
export const IMPORT_JOB_SKILLS_EXCEL_FAIL    = "IMPORT_JOB_SKILLS_EXCEL_FAIL";

export const DOWNLOAD_JOB_SKILLS_TEMPLATE_REQUEST = "DOWNLOAD_JOB_SKILLS_TEMPLATE_REQUEST";
export const DOWNLOAD_JOB_SKILLS_TEMPLATE_SUCCESS = "DOWNLOAD_JOB_SKILLS_TEMPLATE_SUCCESS";
export const DOWNLOAD_JOB_SKILLS_TEMPLATE_FAIL    = "DOWNLOAD_JOB_SKILLS_TEMPLATE_FAIL";

export const CLEAR_JOB_SKILLS_IMPORT_RESULT = "CLEAR_JOB_SKILLS_IMPORT_RESULT";

export const SET_JOB_SKILL_LOADING = "SET_JOB_SKILL_LOADING";
export const CLEAR_JOB_SKILL_ERROR = "CLEAR_JOB_SKILL_ERROR";

// Action creators
export const fetchJobSkillsRequest = (jobId) => ({ type: FETCH_JOB_SKILLS_REQUEST, payload: { jobId } });
export const fetchJobSkillsSuccess = (data)  => ({ type: FETCH_JOB_SKILLS_SUCCESS, payload: data });
export const fetchJobSkillsFail    = (error) => ({ type: FETCH_JOB_SKILLS_FAIL, error });

export const createJobSkillRequest = (payload) => ({ type: CREATE_JOB_SKILL_REQUEST, payload });
export const createJobSkillSuccess = (data)    => ({ type: CREATE_JOB_SKILL_SUCCESS, payload: data });
export const createJobSkillFail    = (error)   => ({ type: CREATE_JOB_SKILL_FAIL, error });

export const updateJobSkillRequest = (id, payload) => ({ type: UPDATE_JOB_SKILL_REQUEST, payload: { id, payload } });
export const updateJobSkillSuccess = (data)        => ({ type: UPDATE_JOB_SKILL_SUCCESS, payload: data });
export const updateJobSkillFail    = (error)       => ({ type: UPDATE_JOB_SKILL_FAIL, error });

export const deleteJobSkillRequest = (id)    => ({ type: DELETE_JOB_SKILL_REQUEST, payload: { id } });
export const deleteJobSkillSuccess = (id)    => ({ type: DELETE_JOB_SKILL_SUCCESS, payload: { id } });
export const deleteJobSkillFail    = (error) => ({ type: DELETE_JOB_SKILL_FAIL, error });

export const importJobSkillsExcelRequest = (file, dryRun = true, action = "add", jobId = null) => ({ type: IMPORT_JOB_SKILLS_EXCEL_REQUEST, payload: { file, dryRun, action, jobId } });
export const importJobSkillsExcelSuccess = (data) => ({ type: IMPORT_JOB_SKILLS_EXCEL_SUCCESS, payload: data });
export const importJobSkillsExcelFail = (error) => ({ type: IMPORT_JOB_SKILLS_EXCEL_FAIL, error });

export const downloadJobSkillsTemplateRequest = () => ({ type: DOWNLOAD_JOB_SKILLS_TEMPLATE_REQUEST });
export const downloadJobSkillsTemplateSuccess = () => ({ type: DOWNLOAD_JOB_SKILLS_TEMPLATE_SUCCESS });
export const downloadJobSkillsTemplateFail = (error) => ({ type: DOWNLOAD_JOB_SKILLS_TEMPLATE_FAIL, error });

export const clearJobSkillsImportResult = () => ({ type: CLEAR_JOB_SKILLS_IMPORT_RESULT });

export const setJobSkillLoading = (loading) => ({ type: SET_JOB_SKILL_LOADING, payload: loading });
export const clearJobSkillError = ()        => ({ type: CLEAR_JOB_SKILL_ERROR });